document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu > summary').forEach(summary => {
    summary.addEventListener('click', e => {
      const link = summary.querySelector('a');
      if (!link) return;

      // PCのみ：親リンクへ遷移
      if (window.innerWidth > 990) {
        e.preventDefault();
        window.location.href = link.getAttribute('href');
      }
    });
  });
});
